var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-flex',[_c('v-btn',{staticClass:"mt-1",style:(_vm.theme),attrs:{"small":"","block":""},on:{"click":function($event){return _vm.placeOrder(1)}}},[_vm._v("Order Now")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }